import { HEADER_SCROLLED, FLASH_MESSAGE_CLEAR } from '../constants'

const initialState = {
  scrolled: false,
  flashMessageCleared: false,
}

export default function reducer(state = initialState, action = { type: null }) {
  switch (action.type) {
    case HEADER_SCROLLED:
      return {
        ...state,
        scrolled: action.payload,
      }
    case FLASH_MESSAGE_CLEAR:
      return {
        ...state,
        flashMessageCleared: true,
      }
    default:
      return state
  }
}
